export default "__VITE_ASSET__1e892314__"